<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.driver_commission_reports_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.staff_name') }}</label>
                    <input type="text"
                        v-model="filter.columns.staff_name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.begin_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.begin_at"
                        :re_init="Boolean(filter.columns.begin_at)"
                        type="datetime"
                        key="advanced_begin_at">
                    </DatePicker>
                </div>
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.end_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.end_at"
                        :re_init="Boolean(filter.columns.end_at)"
                        type="datetime"
                        key="advanced_end_at">
                    </DatePicker>
                </div>
            </div>
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.total_amount_from') }}</label>
                    <input type="text"
                        v-model="filter.columns.total_amount_from"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.total_amount_to') }}</label>
                    <input type="text"
                        v-model="filter.columns.total_amount_to"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('ui.pages.driver_commission_reports.filter.created_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.created_duration"
                        :re_init="Boolean(filter.columns.created_duration)"
                        type="daterange"
                        format="YYYY-MM-DD"
                        key="advanced_created_duration">
                    </DatePicker>
                </div>

            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.driver_commission_reports_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "OperationsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.driver_commission_reports_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
#driver_commission_reports #filter_advanced .el-input--prefix .el-input__inner{
    padding-left: 30px !important;
}
</style>
<style scoped lang="scss">

</style>
